import { GoogleGenAI } from "@google/genai";

interface ParsedApplication {
    companyName?: string;
    jobTitle?: string;
    dateApplied?: string;
    status?: string;
    jobUrl?: string;
    notes?: string;
}

const apiKey = import.meta.env.VITE_GEMINI_API_KEY;

let ai: GoogleGenAI | null = null;
if (apiKey) {
    ai = new GoogleGenAI({ apiKey });
} else {
    console.warn("VITE_GEMINI_API_KEY is not set. AI features will not work.");
}

export async function parseApplicationText(text: string): Promise<ParsedApplication> {
    if (!ai) {
        return {};
    }

    const prompt = `Extract job application information from the user text. Respond in JSON with keys: companyName, jobTitle, dateApplied (YYYY-MM-DD), status, jobUrl, notes.`;

    try {
        const response: any = await ai.models.generateContent({
            model: "gemini-2.5-flash",
            contents: [
                {
                    role: "user",
                    parts: [{ text: `${prompt}\n\n${text}` }]
                }
            ]
        });

        const raw = typeof response.text === "function" ? response.text() : response.text;
        if (!raw) return {};
        const cleaned = raw.replace(/```json\s*|```/g, "");
        return JSON.parse(cleaned);
    } catch (err) {
        console.error("Error parsing application text", err);
        return {};
    }
}
